import {
  type HeatmapFocusKey,
  tileBgColor,
} from "@/bizminer/lib/heatmap/tileColors";
import { Badge } from "@/components/ui/badge.tsx";

export default function ScorePill({
  status,
  label,
}: {
  status: HeatmapFocusKey;
  label: string;
}) {
  return (
    <Badge
      // Hardcoded slate-900: fixed contrast against heatmap tile backgrounds (#aed7a0 etc.), not theme-dependent.
      className="text-slate-900 border-slate-900/10"
      style={{ backgroundColor: tileBgColor(status) }}
      variant="outline"
    >
      {label}
    </Badge>
  );
}
